import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type getScheduleForFutureReceivablesDataType = {
  id: string;
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
};

export default ({
  id,
  successCallback,
  errorCallback,
  resultKey = 'schedulesFutureReceivablesData',
}: getScheduleForFutureReceivablesDataType) =>
  requestAsync({
    url: endpoints.getScheduleForFutureReceivablesUrl(id),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: `${endpoints.getScheduleForFutureReceivablesUrl(id)}`,
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
